import React from 'react'
import ellipsesImage from '../images/ellipsis-dots.png'
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup'
import DropdownButton from 'react-bootstrap/lib/DropdownButton'
import MenuItem from 'react-bootstrap/lib/MenuItem'

class BigTagMenu extends React.Component {
    constructor(props) {
        super(props)

        this.editBigTag = this.editBigTag.bind(this)
        this.newTimer = this.newTimer.bind(this)
        this.newEntry = this.newEntry.bind(this)
    }

    editBigTag() {
        this.props.showModal()
    }

    newTimer(bigTag) {
        this.props.newTimer([bigTag.id])
    }

    newEntry(bigTag) {
        this.props.newTimeEntry([bigTag.id])
    }

    render() {
        const { bigTag, bigTag: { canEdit, canAddTime } } = this.props
        return(
            <ButtonGroup className="big-tag-menu" onMouseOver={this.props.preventModal} onMouseOut={this.props.allowModal}>
                <DropdownButton
                    id="tag-dropdown"
                    title={<img src={ellipsesImage}
                        className="ellipses" alt="Ellipses"/>}
                    pullRight
                    noCaret
                    bsStyle="default"
                    open={this.props.menuOpen}
                    onToggle={(e) => {}}
                    onClick={(e) => {
                        e.stopPropagation()
                        this.props.showDropdown()
                    }}>

                    {canEdit && <MenuItem onClick={(e) => {
                        e.stopPropagation()
                        this.editBigTag()
                    }}>
                        Edit Tag
                    </MenuItem>}

                    {canAddTime && <MenuItem onClick={(e) => {
                        e.stopPropagation()
                        this.newTimer(bigTag)
                    }}>
                        New Timer
                    </MenuItem>}

                    {canAddTime && <MenuItem onClick={(e) => {
                        e.stopPropagation()
                        this.newEntry(bigTag)
                    }}>
                        New Entry
                    </MenuItem>}
                </DropdownButton>
            </ButtonGroup>
        )
    }
}

export default BigTagMenu



// WEBPACK FOOTER //
// ./src/components/big_tag_menu.jsx